<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-knowledge">

        <page-title :title="'Więcej'" :back="false"></page-title>

        <ion-list>
            <div v-for="(item,index) in navigation" :key="item.route" style="background: #f2f2f2">
                <item-menu
                        :index="index+1"
                        :title="item.title"
                        :route="item.route"
                        :disabled="item.disabled"
                        :slug="item.slug">
                </item-menu>
            </div>
        </ion-list>

        <div class="copyright">
            <slide-y-up-transition :duration="700">
                <p v-show="show">Ta aplikacja ({{this.version}}) należy do Kompanii Piwowarskiej</p>
            </slide-y-up-transition>
            <slide-y-up-transition :duration="500" :delay="200">
                <img v-show="show" src="kp-logo.png" alt="Logo Kompanii Piwowarskiej">
            </slide-y-up-transition>
        </div>

        <slide-y-up-transition :duration="700">
            <hr v-show="show"/>
        </slide-y-up-transition>

        <div class="copyright">
            <slide-y-up-transition :duration="700" :delay="400">
                <p v-show="show">
                    <span>Jeżeli uważasz, że treść naszego serwisu narusza zasady </span>
                    <br/>
                    <span>Kodeksu Etyki Reklamy, </span>
                    <span @click="goTo('UserContact')">kliknij tutaj. </span>
                    <span>Dowiedz się więcej o alkoholu na </span>
                    <a href="https://www.abcalkoholu.pl" target="_blank">www.abcalkoholu.pl</a>
                </p>
            </slide-y-up-transition>
            <slide-y-up-transition :duration="700" :delay="800">
                <img v-show="show" src="logo-alkohol-tylko-dla-pelnoletnich.png" alt="Logo alkohol tylko dla pełnoletnich">
            </slide-y-up-transition>
        </div>

    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle.vue';
    import ItemMenu from '@/items/ItemMenu';

    import goTo from '@/mixins/goto';
    import { mapState } from 'vuex';
    import {version} from '../../../package.json';

    export default {
        name: 'MoreIndex',
        mixins: [goTo],
        components: { PageTitle, ItemMenu },
        computed: {
            ...mapState({
                navigation: state => state.config.navigation ? state.config.navigation.more : [],
            }),
        },
        data(){
            return{
                version: version,
                show: false
            }
        },
        mounted(){
            this.show = true;
        }
    }
</script>

<style lang="scss" scoped>
    ion-list{
        padding: 0;
    }
    ion-card-header{
        --background: #ffffff;
    }
    ion-card-content{
        padding: 0 20px 20px 20px;
    }
    ion-item{
        --background: #f2f2f2;
    }
    .copyright{
        margin: 15px 0;
        text-align: center;
        p{
            font-size: 12px;
        }
        img{
            display: inline-block;
            width: 100%;
            height: auto;
            max-width: 180px;
        }
    }
    br{
      display: none;
      @media (min-width: 768px) {
        display: block
      }
    }
</style>
